import { render, staticRenderFns } from "./DownloadExamples.vue?vue&type=template&id=2878b21c&scoped=true"
import script from "./DownloadExamples.vue?vue&type=script&lang=js"
export * from "./DownloadExamples.vue?vue&type=script&lang=js"
import style0 from "./DownloadExamples.vue?vue&type=style&index=0&id=2878b21c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2878b21c",
  null
  
)

export default component.exports